export type PostingExternalComponentsData = {
    [key: string]: {
        action: string;
        // it's not a perfect typing, in perfect world it should be some generic that inherit type per use case
        data: string | Record<string, unknown>;
    };
};

export type FormValues = {
    id?: number;
    category_id: number;
    city_id?: number;
    city_name?: string;
    city_label?: string;
    /**
     * Location specifics
     */
    latitude?: number;
    longitude?: number;
    zoom?: number;
    radius?: number;
    district_id: number | null;
    district_name?: string;
    region_id?: number;
    region_name?: string;
    title?: string;
    components_data?: PostingExternalComponentsData;
    region_label?: string | undefined;
    district_label?: string | undefined;
};

export enum ExternalModulesPlatform {
    mobile = 'mWeb',
    desktop = 'desktop'
}
